import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { IonicModule, Platform } from '@ionic/angular';
import { KeycloakService } from 'keycloak-angular';
import { EventsService } from '../services/events/events.service';
import { SanityService } from '../services/sanity/sanity.service';
import { Article } from '../services/sanity/sanity.types';
import {
  forbrukRoute,
  profilRoute,
  nyttigRoute,
  loginArticleRoute
} from '../routes';

@Component({
  selector: 'app-logginn',
  standalone: true,
  imports: [CommonModule, IonicModule],
  templateUrl: './logginn.component.html',
  styleUrls: ['./forside.page.scss']
})
export class LoggInnComponent {
  isLoggedIn: boolean;
  loggedIn: Promise<boolean>;
  userInfo: Promise<Keycloak.KeycloakProfile>;
  userProfile: any;
  forsideArticles: Article[];
  loading = true;

  constructor(
    private _keycloakService: KeycloakService,
    private _sanitizer: DomSanitizer,
    private _eventsService: EventsService,
    private sanityService: SanityService,
    private router: Router
  ) {}

  ngOnInit() {
    // Vi har fått svar fra keycloak
    this.isLoggedIn = this._keycloakService.isLoggedIn();

    this.sanityService.getForsideArticles().then((res) => {
      this.forsideArticles = res;
    });
  }

  async ionViewDidEnter() {
    if (this.isLoggedIn) {
      this._keycloakService
        .loadUserProfile(true)
        .then((res) => {
          this.userProfile = res;
          if (
            this.userProfile?.attributes?.kunde_id &&
            this.userProfile.attributes.kunde_id.length > 0
          ) {
            this.router.navigate([forbrukRoute]); //Til forbruk hvis vi har kunde-id
          } else {
            this.router.navigate([profilRoute]); //til profil hvis vi må kjøre sms-løypa
          }
        })
        .catch();
    } else {
      this.loading = false;
    }
  }

  async login() {
    if (!this.isLoggedIn) {
      await this._keycloakService
        .login()
        .then((res) => {
          this._eventsService.publishLoggedIn(true);
          // Vi er tilbake fra login
          //Vi må redirecte til profil hvis vi ikke har kunde-id
          this._keycloakService.loadUserProfile(true).then((prof) => {
            const anyProf: any = prof;
            if (
              prof &&
              anyProf.attributes &&
              anyProf.attributes.kunde_id &&
              anyProf.attributes.kunde_id.length > 0
            ) {
              this.router.navigate([forbrukRoute]); //Til forbruk hvis vi har kunde-id
            } else {
              this.router.navigate([profilRoute]); //til profil hvis vi må kjøre sms-løypa
            }
          });
        })
        .catch((err) => {
          // console.log('feilet, men vi prøver...');
          // window.location.reload();
        });
    } else {
      await this._keycloakService
        .logout()
        .then((res) => {
          //window.location.reload();
          this.isLoggedIn = false;
        })
        .catch((err) => {
          // console.log('logout feilet kanskje, men ...');
          this.isLoggedIn = false;
        });
    }
  }

  async nybruker() {
    await this._keycloakService
      .register()
      .then((res) => {
        this._eventsService.publishLoggedIn(true);
        // console.log('vi er tilbake fra registrer ny bruker... forside');

        this._keycloakService.loadUserProfile(true).then((res2) => {
          const prof: any = this._keycloakService.getKeycloakInstance().profile;
          if (
            prof &&
            prof.attributes &&
            prof.attributes.kunde_id &&
            prof.attributes.kunde_id.length > 0
          ) {
            this.router.navigate([nyttigRoute]); //Til nytt og nyttig hvis vi har kunde id
          } else {
            this.router.navigate([profilRoute]); //til profil hvis vi må kjøre sms-løypa
          }
        });

        this.ionViewDidEnter();
      })
      .catch((err) => {
        // TODO: håndtere noe her?
      });
  }

  getBackground(background: string) {
    return this._sanitizer.bypassSecurityTrustStyle('url(' + background + ')');
  }

  navToArticle(url: string) {
    const navExtras = {
      state: {
        sender: 'forside',
        page: url
      }
    };
    this.router.navigate([loginArticleRoute], navExtras);
  }
}
